	import React from "react";

	const boardContextStructure = {
		userPropsKpi: {
			value: null,
		},
		boardElementList: {
			value: null,
			set:  () => {},
		},
		selectedElement: {
			value: null,
			set:  () => {},
		}
	}
	export default React.createContext(boardContextStructure);